module.exports = __webpack_public_path__ + "img/graph_region.338e7e3e.png";